module.exports = __webpack_public_path__ + "img/homepage_1.807601dd.jpg";